const context = require.context('./configurations', false, /\.js$/);
const events = context.keys().map(key => context(key).default);


// todo - make this an event class that takes in the event data instead of appending to the object like below
// for each event, add snake_name
for (let event of events){
  event.snakeName = event.name.replaceAll(/ /g, "_").toLowerCase();
  event.snakeNameUpper = event.snakeName.toUpperCase();
  event.camelName = event.snakeName.replace(/(_\w)/g, function(m){return m[1].toUpperCase();});
  event.pascalName = event.snakeName.replace(/(_\w)/g, function(m){return m[1].toUpperCase();}).replace(/^\w/, c => c.toUpperCase());
};

export const SETTINGS_EVENTS_CONFIG_KEYS = events.map((event)=>event.snakeName);

export function buildSettings(env){
  let featureList = {};
  events.forEach((event)=>{
    featureList[event.snakeName] = event.isBuiltEnvironmentOverride[env] ?? event.isBuiltByDefault; // use nullish coalescing (??) to distinguish "not specified" from "explicitly false"
  });
  return featureList;
}

export function eventStrings(lang){
  let eventStrings = {};
  events.forEach((event)=>{
    let localization = event.localization[lang];
    
    const settingsHeader = localization.settingsHeader || localization.title;
    
    if (lang === "fr"){
      eventStrings["event_title_" + event.snakeName] = localization.title;
      eventStrings["settings_global_events_" + event.snakeName + "_header"] = settingsHeader;
      eventStrings["settings_global_events_" + event.snakeName + "_are_enabled"] = "Les événements de " + settingsHeader + " sont activés";
      eventStrings["settings_global_events_" + event.snakeName + "_are_disabled"] = "Les événements de " + settingsHeader + " sont désactivés";
    } else {
        eventStrings["event_title_" + event.snakeName] = localization.title;
        eventStrings["settings_global_events_" + event.snakeName + "_header"] = settingsHeader;
        eventStrings["settings_global_events_" + event.snakeName + "_are_enabled"] = settingsHeader + " Events Are Enabled";
        eventStrings["settings_global_events_" + event.snakeName + "_are_disabled"] = settingsHeader + " Events Are Disabled";
    } 
  });
  return eventStrings;
}

export default events;